import { defineComponent, createElementBlock, createBlock, openBlock, createElementVNode, toDisplayString, capitalize, Fragment, renderList, createCommentVNode, withModifiers, normalizeClass, unref, withCtx, createTextVNode, createVNode } from "vue";
import FlowDropdown from "../../components/FlowDropdown.vue.js";
import FlowDropdownItem from "../../components/FlowDropdownItem.vue.js";
import _sfc_main$1 from "../../components/FlowIcon.vue.js";
const _hoisted_1 = {
  key: 0,
  class: "header-group"
};
const _hoisted_2 = { class: "header-group-label" };
const _hoisted_3 = { class: "header-group-items" };
const _hoisted_4 = {
  key: 0,
  class: "header-group-item"
};
const _hoisted_5 = ["href", "onClick"];
const _hoisted_6 = {
  key: 1,
  class: "header-group-item"
};
const _hoisted_7 = ["href"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "HeaderItemGroup",
  props: {
    group: {},
    isEditable: { type: Boolean },
    isMobile: { type: Boolean },
    resolveInternalLinks: { type: Function },
    linkIsActive: { type: Function }
  },
  emits: ["navigate"],
  setup(__props) {
    return (_ctx, _cache) => {
      return _ctx.isMobile ? (openBlock(), createElementBlock("div", _hoisted_1, [
        createElementVNode("div", _hoisted_2, toDisplayString(_ctx.group.title || capitalize(_ctx.group.type)), 1),
        createElementVNode("ul", _hoisted_3, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.group.children, (item) => {
            return openBlock(), createElementBlock(Fragment, {
              key: item.uid
            }, [
              (item.type === "guide" || item.type === "reference") && (item.show || _ctx.isEditable) ? (openBlock(), createElementBlock("li", _hoisted_4, [
                createElementVNode("a", {
                  class: normalizeClass(["header-item-link", {
                    "header-item-active": _ctx.linkIsActive(item),
                    "header-item-ghost": !item.show
                  }]),
                  href: _ctx.resolveInternalLinks(item),
                  onClick: withModifiers(($event) => _ctx.$emit("navigate", item.uid, item.type), ["prevent"])
                }, toDisplayString(item.title || capitalize(item.type)), 11, _hoisted_5)
              ])) : item.type === "link" && item.show ? (openBlock(), createElementBlock("li", _hoisted_6, [
                createElementVNode("a", {
                  class: "header-item-link",
                  href: item.link || "#",
                  rel: "noopener noreferrer",
                  target: "_blank"
                }, toDisplayString(item.title || capitalize(item.type)), 9, _hoisted_7)
              ])) : createCommentVNode("", true)
            ], 64);
          }), 128))
        ])
      ])) : (openBlock(), createBlock(unref(FlowDropdown), {
        key: 1,
        static: ""
      }, {
        default: withCtx(({ open }) => [
          createElementVNode("button", {
            class: normalizeClass(["header-item-link header-group-link", {
              "header-item-active": _ctx.linkIsActive(_ctx.group),
              "header-group-active": open
            }]),
            type: "button"
          }, [
            createTextVNode(toDisplayString(_ctx.group.title || capitalize(_ctx.group.type)) + " ", 1),
            createVNode(unref(_sfc_main$1), {
              icon: open ? "ChevronUp" : "ChevronDown",
              width: "14px"
            }, null, 8, ["icon"])
          ], 2)
        ]),
        items: withCtx(() => [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.group.children, (item) => {
            return openBlock(), createElementBlock(Fragment, {
              key: item.uid
            }, [
              (item.type === "guide" || item.type === "reference") && (item.show || _ctx.isEditable) ? (openBlock(), createBlock(unref(FlowDropdownItem), {
                key: 0,
                class: normalizeClass(["header-group-item", {
                  "header-group-item-active": _ctx.linkIsActive(item),
                  "header-group-item-ghost": !item.show
                }]),
                href: _ctx.resolveInternalLinks(item),
                onClick: withModifiers(($event) => _ctx.$emit("navigate", item.uid, item.type), ["prevent"])
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(item.title || capitalize(item.type)), 1)
                ]),
                _: 2
              }, 1032, ["class", "href", "onClick"])) : item.type === "link" && item.show ? (openBlock(), createBlock(unref(FlowDropdownItem), {
                key: 1,
                href: item.link || "#",
                rel: "noopener noreferrer",
                target: "_blank"
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(item.title || capitalize(item.type)), 1)
                ]),
                _: 2
              }, 1032, ["href"])) : createCommentVNode("", true)
            ], 64);
          }), 128))
        ]),
        _: 1
      }));
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=HeaderItemGroup.vue.js.map
